import { useState } from 'react';
import { LAYER_CONFIG, BUILDING_COLORS, CATEGORY_MAP } from './mapConstants';

export const MapLegend = ({ activeLayers, showBuildings, showHeatmap, stats }) => {
  const [collapsed, setCollapsed] = useState(false);

  const hasActiveBoundary = activeLayers.some(l => l);
  if (!hasActiveBoundary && !showBuildings && !showHeatmap) return null;

  return (
    <div style={{
      position: 'absolute', bottom: 30, right: 12, zIndex: 1000,
      background: '#ffffff', borderRadius: 10,
      boxShadow: '0 10px 30px rgba(15,23,42,0.15), 0 2px 6px rgba(15,23,42,0.08)',
      border: '1px solid #e2e8f0',
      minWidth: collapsed ? 100 : 190, maxWidth: 220, pointerEvents: 'auto',
      fontFamily: "'Segoe UI', Roboto, Arial, sans-serif",
      overflow: 'hidden',
    }}>
      <div
        style={{
          cursor: 'pointer', padding: '8px 12px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: '#f8fafc', borderBottom: collapsed ? 'none' : '1px solid #e2e8f0',
        }}
        onClick={() => setCollapsed(!collapsed)}
      >
        <span style={{ fontSize: 12, fontWeight: 700, color: '#334155', letterSpacing: 0.3, display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="bi bi-map-fill" style={{ fontSize: 12, color: '#0891b2' }}></i> Legend
        </span>
        <i className={`bi bi-chevron-${collapsed ? 'up' : 'down'}`} style={{ fontSize: 10, color: '#64748b' }}></i>
      </div>

      {!collapsed && (
        <div style={{ padding: '10px 12px', fontSize: 12 }}>
          {/* Active boundary layers */}
          {LAYER_CONFIG.map((layer, i) => (
            activeLayers[i] && (
              <div key={layer.key} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
                <span style={{ width: 22, height: 3, backgroundColor: layer.color, borderRadius: 1, flexShrink: 0 }}></span>
                <span style={{ color: '#1e293b' }}>{layer.label}</span>
              </div>
            )
          ))}

          {/* Building categories */}
          {showBuildings && (
            <>
              {LAYER_CONFIG.some((_, i) => activeLayers[i]) && <div style={{ borderTop: '1px solid #e2e8f0', margin: '8px 0' }}></div>}
              <div style={{ fontWeight: 700, marginBottom: 6, color: '#334155', fontSize: 11, letterSpacing: 0.3, textTransform: 'uppercase' }}>Buildings</div>
              {Object.entries(BUILDING_COLORS).map(([catId, color]) => (
                <div key={catId} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ width: 12, height: 12, backgroundColor: color, borderRadius: 3, opacity: 0.85, flexShrink: 0 }}></span>
                  <span style={{ color: '#1e293b' }}>{CATEGORY_MAP[catId]}</span>
                </div>
              ))}
            </>
          )}

          {/* Heatmap gradient scale */}
          {showHeatmap && (
            <>
              {(showBuildings || LAYER_CONFIG.some((_, i) => activeLayers[i])) && <div style={{ borderTop: '1px solid #e2e8f0', margin: '8px 0' }}></div>}
              <div style={{ fontWeight: 700, marginBottom: 6, color: '#334155', fontSize: 11, letterSpacing: 0.3, textTransform: 'uppercase' }}>
                Crowding density
              </div>
              <div style={{
                height: 10, borderRadius: 5,
                background: 'linear-gradient(90deg, #0ea5e9 0%, #22c55e 25%, #eab308 50%, #f97316 70%, #dc2626 100%)',
                marginBottom: 4, border: '1px solid #cbd5e1',
              }}></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10.5, color: '#64748b' }}>
                <span>Sparse</span>
                <span>Dense</span>
              </div>
              <div style={{ fontSize: 10.5, color: '#94a3b8', marginTop: 4, fontStyle: 'italic' }}>
                Weighted by registered members
              </div>
            </>
          )}

          {/* Summary stats */}
          {stats && (showBuildings || showHeatmap) && (stats.total > 0) && (
            <>
              <div style={{ borderTop: '1px solid #e2e8f0', margin: '8px 0' }}></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span style={{ fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.3, fontWeight: 600 }}>Buildings</span>
                <span style={{ fontSize: 13, color: '#0f172a', fontWeight: 700 }}>{stats.total.toLocaleString()}</span>
              </div>
              {typeof stats.members === 'number' && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 2 }}>
                  <span style={{ fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.3, fontWeight: 600 }}>Members</span>
                  <span style={{ fontSize: 13, color: '#0f172a', fontWeight: 700 }}>{stats.members.toLocaleString()}</span>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
